module.exports = __webpack_public_path__ + "h5/img/funv-card.ff759973.jpg";